import React, { useState, useEffect, useRef, useCallback, useReducer, useMemo } from "react";
import styled from "styled-components";
import PostsAPI from "../../../api/PostsAPI";
import { resolveFileUrl } from "constants/config";

import { Button } from "../../ui-kit/styled-templates";
import { Sidebar } from "arui-feather/sidebar";
import UpdatePostForm from "../tools/UpdatePostForm";
import toast from "react-hot-toast";
import { useStorageListener } from "../../../hooks/useStorage";

import './style.css'

import check_news from "./check_news.svg";
import exclamation_image from "./exclamation-mark.svg";

export default function UserPostsPanel(props) {
    const {
        userId,
        canAdd = false,
        canEdit = false,
        showtPostsOnModeration = true,
        onPostClick = pp => {

        }
    } = props;

    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(false);

    const [selectedId, setSelectedId] = useState(undefined);

    const [addVisible, setAddVisible] = useState(false);

    const uData = useStorageListener("user", {});

    useEffect(() => {
        if (loading == true) {
            return;
        }
        setLoading(true);
        PostsAPI.getUserPosts(userId).then(arr => {
            console.log('getUserPosts: arr = ', arr);
            let fArr = arr.filter(x => (x.userId == userId));
            console.log('getUserPosts: fArr = ', fArr);
            setPosts(fArr);
            setLoading(false);
        });
    }, [userId]);

    if (posts.length == 0 && loading == true) {
        return (
            <div>
                загрузка...
            </div>
        );
    }

    let currentUserIsAdmin = (uData?.userRole == "admin");

    let selectedPost = (selectedId == undefined) ? undefined : posts.find(a => a.id == selectedId);

    let fPosts = posts;

    if (showtPostsOnModeration == false) {
        fPosts = fPosts.filter(x => x.isModerated == true);
    }
    if (userId != undefined){
        fPosts = fPosts.filter(x => (x.userId == userId))
    }

    console.log("render: posts = ", posts);

    return (
        <Wrapper>

            {canAdd == false ? null :
                <AddPlaceholder>
                    <Button onClick={() => {
                        setAddVisible(true);
                    }}>
                        Добавить пост
                    </Button>
                </AddPlaceholder>
            }

            <PostsPlaceholder>

                {fPosts.map((a, i) => {
                    return (
                        <PostItem key={i}>
                            <PostAvatar src={resolveFileUrl(a.avatar)} onClick={() => {
                                if (a.url != undefined && a.url != "") {
                                    window.open(a.url, "_blank");
                                } else {
                                    onPostClick(a);
                                }

                            }}>
                            </PostAvatar>
                            <PostContentPlaceholder>
                                <PostName onClick={() => {
                                    if (a.url != undefined && a.url != "") {
                                        window.open(a.url, "_blank");
                                    } else {
                                        onPostClick(a);
                                    }
                                }}>
                                    {a.name}
                                    {canEdit == false ? null :
                                        <span style={{ marginLeft: 5 }}>
                                            {a.isModerated != true ?
                                                <div style={{ color: "red", fontSize: '12px', fontWeight: 'default' }}>
                                                    <div style={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        alignItems: "center"
                                                    }}>
                                                        <img src={exclamation_image} style={{
                                                            height: "15px",
                                                            display: "inline-block",
                                                            marginRight: 5
                                                        }} />
                                                        <span>
                                                            модерация не пройдена
                                                        </span>
                                                    </div>
                                                    {(a.moderationComment == undefined || a.moderationComment == "") ? null :
                                                        <div>
                                                            {a.moderationComment}
                                                        </div>
                                                    }
                                                </div>
                                                :
                                                <img src={check_news}
                                                     style={{ height: "15px", display: "inline-block" }} />
                                            }
                                        </span>
                                    }
                                </PostName>
                                <PostDescription onClick={() => {
                                    if (a.url != undefined && a.url != "") {
                                        window.open(a.url, "_blank");
                                    } else {
                                        onPostClick(a);
                                    }
                                }}>
                                    {a.description}
                                </PostDescription>
                                {canEdit == false ? null :
                                    <div>
                                        <span style={{ fontSize: "12px", marginTop: 8, color: 'blue' }} onClick={() => {
                                            setSelectedId(a.id);
                                        }}>
                                            редактировать
                                        </span>
                                    </div>
                                }
                            </PostContentPlaceholder>
                        </PostItem>
                    );
                })}

            </PostsPlaceholder>

            <Sidebar width={Math.min(820, window.innerWidth)} visible={addVisible} onCloserClick={() => {
                setAddVisible(false);
            }}>

                {addVisible == false ? null :
                    <div>

                        <UpdatePostForm
                            isAdmin={currentUserIsAdmin}
                            loading={loading}
                            onSave={async d => {
                                setLoading(true);
                                await PostsAPI.createPost({
                                    ...d,
                                    userId: userId
                                });
                                let arr = await PostsAPI.getUserPosts(userId);
                                setPosts(arr);
                                setLoading(false);
                                toast.success("Изменения сохранены");
                                setAddVisible(false);
                            }}
                        />

                    </div>
                }

            </Sidebar>

            <Sidebar width={Math.min(820, window.innerWidth)} visible={(selectedPost != undefined)}
                     onCloserClick={() => {
                         setSelectedId(undefined);
                     }}>

                {selectedPost == undefined ? null :
                    <div>

                        <UpdatePostForm
                            isAdmin={currentUserIsAdmin}
                            canDelete={true}
                            {...selectedPost}
                            loading={loading}
                            onSave={async d => {
                                setLoading(true);
                                await PostsAPI.updatePost({
                                    ...d,
                                    id: selectedPost.id
                                });
                                let arr = await PostsAPI.getUserPosts(userId);
                                setPosts(arr);
                                setLoading(false);
                                toast.success("Изменения сохранены");
                                setSelectedId(undefined);
                            }}
                            onDelete={async () => {
                                setLoading(true);
                                await PostsAPI.deletePost(selectedPost?.id);
                                let arr = await PostsAPI.getUserPosts(userId);
                                setPosts(arr);
                                setSelectedId(undefined);
                                toast.success("Пост удален");
                                setLoading(false);
                            }}
                        />

                    </div>
                }

            </Sidebar>

        </Wrapper>
    );
}

const Wrapper = styled.div`

`;

const AddPlaceholder = styled.div`
  margin-bottom: 20px;
`;

const PostsPlaceholder = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
`;

const PostItem = styled.div`
  margin: 10px;
  border-radius: 12px;
  cursor: pointer;
  border: 1px solid rgb(227, 236, 244);

  :hover {
    opacity: 0.7;
  }
`;

const PostAvatar = styled.div`
  width: 100%;
  height: 200px;
  margin-bottom: 10px;
  box-sizing: border-box;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  background-image: url("${({ src }) => src}");
`;

const PostContentPlaceholder = styled.div`
  box-sizing: border-box;
  padding: 20px;
`;

const PostName = styled.div`
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
`;

const PostDescription = styled.div`
  font-size: 13px;
  line-height: 18px;
`;